module.exports = __webpack_public_path__ + "img/prefix_suffix_black.fdf8ee36.svg";